// Constant only, use JointEnrollmentErrors for type safety
export const JOINT_ENROLLMENT_ERRORS = {
  INVALID_TOKEN: 'INVALID_TOKEN',
  INVALID_EMAIL: 'INVALID_EMAIL',
  APPLICATION_ABANDONED: 'APPLICATION_ABANDONED',
  MANUAL_REVIEW_DOCUMENT_SUBMISSION_FAILED: 'MANUAL_REVIEW_DOCUMENT_SUBMISSION_FAILED',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
} as const
